var IGResource = function() {
  var self = this;

  self.refresh = function(username, options) {
    request.post($.extend(true, {
      url: '/api/instagram/users',
      data: {
        username: username
      }
    }, options));
  };

  self.search = function(query, options) {
    request.get($.extend(true, {
      url: '/api/instagram/search/' + query
    }, options))
  }
};

window.igResource = new IGResource();